import React, { useState, useContext } from 'react';
import { Position, NodeResizer, useNodeId, useStore, getNodesBounds } from 'reactflow';
import PanToolIcon from '@mui/icons-material/PanTool';
import { NodeContext } from '../index';
import { Alert, Box, Button, Collapse, Divider, IconButton, Paper, Input, Typography, Grid, FormControl, Select, MenuItem, InputLabel, useTheme, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from "@mui/material";

const rx = 0;
const ry = 0;
const width = 200;
const height = 200;




const Group = ({data, selected}) => {

  const [nodes, setNodes] = useContext(NodeContext);
  const nodeID = useNodeId();

  const zoomSelector = (s) => s.transform[2];
  const zoomLevel = useStore(zoomSelector);
  const variableFontSize = Math.floor(20 / useStore(zoomSelector)) + 'pt';
  const variableHeight = Math.floor(40 / useStore(zoomSelector)) + 'px';
  const variableWidth = Math.floor( 300 / useStore(zoomSelector)) + 'px';
  // console.log(variableFontSize);

  const handleNodeLabelUpdate = (e) => {
    // console.log(e.target.value);
    for (let index in nodes) {
      if (nodes[index].id === nodeID) {
        nodes[index].data.label = e.target.value;
        setNodes(nodes);
      }
    }
  }

  const getNodeWidth = () => {
    for (let index in nodes) {
      if (nodes[index].id === nodeID) {
        let currentNode = [nodes[index]];
        return getNodesBounds(currentNode);
      }
    }
  }

  const currentNodeWidth = getNodeWidth().width;
  const textSizerVariable = currentNodeWidth * zoomLevel;


  return (
    <>        
      <NodeResizer keepAspectRatio={true} isVisible={selected} minWidth={200} minHeight={200} maxWidth={1000} maxHeight={1000} />
      {textSizerVariable < 65 ? (
          <>
              <div style={{ backgroundColor: 'grey', width: '100%', height: '30px' }}>
              <div style={{ marginTop: '10px', backgroundColor: 'black', width: '100%', height: '10px' }}></div>
              </div>
        </>
      ) : (
        (textSizerVariable < 125 ? (
          <>
            <p style={{ fontSize: '3em', marginTop: 0, minHeight: '20%', maxHeight: '30%', paddingLeft: '3px', overflow: 'hidden', textAlign: 'left', backgroundColor: "grey", width: "100%" }}>
              {data.label}
            </p>
          </>
        ):(
          (textSizerVariable < 250 ? (
          <>
            <Typography style={{ fontSize: '3em', marginTop: 0, maxHeight: '30%', paddingLeft: '3px', overflow: 'hidden', textAlign: 'left', backgroundColor: "grey", width: "100%" }}>
              Zone Name: {data.label}
              <br />Description: {data.description}
              <br />Segmentation Type(s): {data.segmentationType.map((item, index) => `${index+1}.) ${item} ` )}
            </Typography>
          </>
          ) : (
          <>
            <p style={{ fontSize: '1em', marginTop: 0, maxHeight: '30%', paddingLeft: '3px', overflow: 'hidden', textAlign: 'left', backgroundColor: "grey", width: "100%" }}>
              Zone Name: {data.label}
              <br />Description: {data.description}
              <br />Segmentation Type(s): {data.segmentationType.map((item, index) => `${index+1}.) ${item} ` )}
            </p>
          </>
          ))
         )
        )
        
      )}
    </>
  )
};

function PanTool() {
  return (
    <>
      <div>
        {/* Use the class specified at node.dragHandle here */}
        <span className="custom-drag-handle" >
          <PanToolIcon sx={{ fontSize: 'small', position: 'absolute', top: 5, right: 5 }} />
        </span>
      </div>
    </>
  );
}


export default Group;